import { WorkflowUsageDetailsState } from "@idw-types/state/workflow-usage-details-state";
import { CustomizeBySearchTypes } from "@enums/customize-by-search-types";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";
import { WorkflowUsageDetailsActionTypes, WorkflowUsageDetailsActions } from "../actions/workflow-usage-details-actions";

export const initialWorkflowUsageDetailsState: WorkflowUsageDetailsState = {
    searchFilters: {
        customizeBySearchType: CustomizeBySearchTypes.WORKFLOW,
        companyId: null,
        relyingPartyId: null,
        rpServiceId: null,
        workflowId: null,
        startDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).startDate,
        endDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).endDate,
        timeRangeType: TimeRangeTypes.CURRENT_MONTH
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        workflowSankeyResults: null,
        workflowResultsDetails: null
    }
};

export const workflowUsageDetailsReducer = (
    state: WorkflowUsageDetailsState = initialWorkflowUsageDetailsState,
    action: WorkflowUsageDetailsActions
): WorkflowUsageDetailsState => {
    switch (action.type) {
        case WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialWorkflowUsageDetailsState.searchResults }
                        : { ...state.searchResults }),
                    isLoading: action.payload.isLoading
                }
            };
        case WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    searchDate: new Date(),
                    ...action.payload.workflowUsageDetailsSearchResults,
                }
            };
        default:
            return state;
    }
};